<template>
	<ActivityLayout class="unknown-activity">
		<template #badge>
			<UnknownActivityBadge />
		</template>
		<template #text>
			<p>{{ translate( "text", {
				discriminator: activity.discriminator,
				activityType: activity.activityType
			} ) }}</p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "./ActivityLayout.vue";
import UnknownActivityBadge from "./UnknownActivityBadge";

export default {
	name: "UnknownActivity",
	components: {
		ActivityLayout,
		UnknownActivityBadge,
	},
	props: {
		/** { changedAt:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.UnknownActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
